export function transformProfileErrors(errors: any): Record<string, { error: string; [properties: string]: any }> {
  if (errors === undefined) {
    return {};
  }
  const tmp = JSON.parse(JSON.stringify(errors));
  const formErrors = {};

  if (tmp.properties?.length) {
    Object.assign(formErrors, tmp.properties[0].error);
    delete tmp.properties;
  }

  Object.assign(formErrors, tmp);

  Object.keys(formErrors).forEach(property => {
    const error = formErrors[property][0].error;
    formErrors[property] = {
      ...formErrors[property][0],
      error: error === 'invalid' ? `${error}_${property}` : error,
    };
  });

  return formErrors;
}
